import React from 'react';
import { Card, CardContent, Flex, FlexItem, Base, Text, AiSpinner, Stack, } from '@stepstone-genesis/components';
import { WarningIcon } from '@stepstone-genesis/icons';
// import { getLang } from 'modules/hub/components/AMAChat/utils/cookies';
import Markdown from 'modules/hub/components/AMAChat/shared/Markdown';
import Feedback from './Feedback';
import labels from 'modules/hub/components/AMAChat/constants/labels/ama';
const Response = ({ role, showFeedback, 
// showRatePrompt,
content, children, messageId, lang, 
// conversationId,
// sessionToken,
thumbs, dislikeOption, turn, userMessageNumber, sessionId, companyId, amaConversationID, }) => {
    const isBetaMessage = content?.includes('Stepstone AI – Beta');
    const isLoadingState = !content && children;
    let betaHeader = '';
    let betaBody = '';
    if (isBetaMessage && content) {
        const parts = content.split('\n\n');
        betaHeader = parts[0].replace(/\*\*/g, ''); // Remove ** markdown syntax
        betaBody = parts.slice(1).join('\n\n'); // Rest of the content
    }
    // userMessageNumber (FE position of the question this answer follows) is the
    // tracking counter — kept in lockstep with questionSubmitted's message#.
    const elementActioned = content ? 'answer' : 'noAnswer';
    const answerVisiblePayload = messageId && role === 'assistant'
        ? JSON.stringify({
            linkName: `${elementActioned}Generated`,
            componentState: 'conversationStarted',
            elementActioned,
            elementAction: 'generated',
            elementActionValue: `message${userMessageNumber}`,
            amaConversationID: amaConversationID || 'noValue',
        })
        : undefined;
    return (React.createElement(Base, { "data-response-id": messageId, ...(answerVisiblePayload && {
            'data-atx-onvisibleelement-payload': answerVisiblePayload,
        }) },
        React.createElement(Flex, { flxDirection: "column", id: "res" },
            React.createElement(FlexItem, null,
                React.createElement(Card, { variant: "compact", id: "res-card", sx: {
                        width: '100%',
                        borderColor: 'colorBorderSubdued',
                        borderWidth: 'size01',
                        borderStyle: role === 'assistant' ? 'none' : 'solid',
                        borderRadius: role === 'assistant' ? 'radiusNone' : 'radiusL4',
                        boxShadow: 'boxShadowNone',
                    } },
                    React.createElement(CardContent, { sx: {
                            padding: role === 'assistant' && !isBetaMessage
                                ? 'spaceNone'
                                : 'spaceM',
                        } },
                        isBetaMessage ? (React.createElement(React.Fragment, null,
                            React.createElement(Flex, { flxItems: "start", gap: "spaceS", sx: {
                                    backgroundColor: 'colorBackgroundWarningDefault',
                                    padding: 'spaceS',
                                    borderRadius: 'radiusM2',
                                    margin: '-8px',
                                    marginBottom: 'spaceM',
                                } },
                                React.createElement(WarningIcon, { color: "colorStatusWarningFg", size: "small" }),
                                React.createElement(Flex, { flxDirection: "column", sx: { flex: 1 } },
                                    React.createElement(Text, { size: "xs", fontWeight: "fontWeightBold" }, betaHeader))),
                            betaBody && (React.createElement(Text, { size: "xs", color: "colorTextPrimaryDefault", sx: { display: 'block', lineHeight: 'lineHeightXs' } }, betaBody)))) : (content && React.createElement(Markdown, { role: role }, content)),
                        showFeedback && turn != null && sessionId && companyId && (React.createElement(Feedback, { sx: { marginTop: 'spaceM' }, lang: lang, companyId: companyId, sessionId: sessionId, turn: turn, userMessageNumber: userMessageNumber, thumbs: thumbs, dislikeOption: dislikeOption, amaConversationID: amaConversationID })),
                        children && isLoadingState && (React.createElement(Stack, { direction: 'vertical' },
                            React.createElement(AiSpinner, { variant: "animated" }),
                            React.createElement(Text, { size: "small" }, labels[lang].processing))),
                        children && !isLoadingState && (React.createElement(Flex, { mt: content ? 'spaceM' : 'spaceNone' }, children))))))));
};
export default Response;
